import { validate, errors } from "com";

const { ValidationError } = errors;

export const PAGINATION_LIMITS = {
  MIN_LIMIT: 1,
  MAX_LIMIT: 100,
  MIN_OFFSET: 0,
} as const;

export const PAYMENT_LIMITS = {
  MIN_AMOUNT: 0.5,
  MAX_AMOUNT: 10000.0,
} as const;

export const VALID_ORDER_STATUSES = ["draft", "placed", "pending", "paid", "fulfilled", "canceled"] as const;
export type OrderStatus = (typeof VALID_ORDER_STATUSES)[number];

export function validateLimit(limit: number): void {
  validate.number(limit);

  if (limit < PAGINATION_LIMITS.MIN_LIMIT || limit > PAGINATION_LIMITS.MAX_LIMIT) {
    throw new ValidationError("Limit out of range", {
      provided: limit,
      min: PAGINATION_LIMITS.MIN_LIMIT,
      max: PAGINATION_LIMITS.MAX_LIMIT,
    });
  }
}

export function validateOffset(offset: number): void {
  validate.number(offset);

  if (offset < PAGINATION_LIMITS.MIN_OFFSET) {
    throw new ValidationError("Offset must be non-negative", {
      provided: offset,
    });
  }
}

export function validateOrderStatus(status: string): void {
  if (!VALID_ORDER_STATUSES.includes(status as OrderStatus)) {
    throw new ValidationError("Invalid order status", {
      provided: status,
      validStatuses: VALID_ORDER_STATUSES,
    });
  }
}

export function validatePaymentAmount(totalAmount: number): void {
  validate.number(totalAmount);

  if (totalAmount < PAYMENT_LIMITS.MIN_AMOUNT) {
    throw new ValidationError("Order amount below minimum", {
      provided: totalAmount,
      minimum: PAYMENT_LIMITS.MIN_AMOUNT,
      currency: "EUR",
    });
  }

  if (totalAmount > PAYMENT_LIMITS.MAX_AMOUNT) {
    throw new ValidationError("Order amount exceeds maximum", {
      provided: totalAmount,
      maximum: PAYMENT_LIMITS.MAX_AMOUNT,
      currency: "EUR",
    });
  }
}

export function validateStripeSessionId(sessionId: string): void {
  validate.string(sessionId, "Session ID");

  if (!sessionId.startsWith("cs_")) {
    throw new ValidationError("Invalid Stripe session ID format", {
      provided: sessionId.substring(0, 10),
      expectedPrefix: "cs_",
    });
  }
}
